import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import styles from "@website/ui/auto-complete/auto-complete.module.scss";
import { AutoCompletePropertiesType } from "@website/ui/auto-complete/auto-complete.types";
import { useEnd, useStart, useSwap } from "@website/ui/auto-complete/hooks";
import { Chips } from "@website/ui/chips";
import { ListItem } from "@website/ui/list-item";
import { Loading } from "@website/ui/loading";
import { PopoverFull } from "@website/ui/popover-full";
import { SearchField } from "@website/ui/search-field";
import { TextField } from "@website/ui/text-field";
import { TopAppBar } from "@website/ui/top-app-bar";
import { SizeType } from "@website/ui/types";
import { FC } from "react";
export const AutoComplete: FC<AutoCompletePropertiesType> = properties => {
  const $ = _c(67);
  const {
    className,
    inputClassName,
    parts,
    error,
    fullWidth,
    onSwap,
    hideBorder,
    hasDropdownIcon,
    labelClassName,
    hideSearchBar,
    hideHeader,
    disabled
  } = properties;
  const {
    isMobile
  } = useViewPort();
  const {
    startTextFieldProperties,
    startItemsProperties,
    startPopoverProperties,
    startPopoverSearchFieldProperties,
    startHistoryItemsProperties,
    startTopAppBarProperties
  } = useStart(properties);
  const {
    endTextFieldProperties,
    endItemsProperties,
    endPopoverProperties,
    endPopoverSearchFieldProperties,
    endHistoryItemsProperties,
    endTopAppBarProperties,
    endtags
  } = useEnd(properties);
  const {
    swapButtonProperties
  } = useSwap(properties);
  const t0 = `${styles["auto-complete"]} ${fullWidth ? styles["full-width"] : ""} ${className ?? ""}`;
  let t1;
  if ($[0] !== hasDropdownIcon) {
    t1 = hasDropdownIcon && <MaterialIcon name="arrow_drop_down" variant="fill" />;
    $[0] = hasDropdownIcon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `styles["input"] ${hideBorder && "border-none"}`;
  let t3;
  if ($[2] !== disabled || $[3] !== inputClassName || $[4] !== labelClassName || $[5] !== startTextFieldProperties || $[6] !== t1 || $[7] !== t2) {
    t3 = <div className={styles.start}><TextField {...startTextFieldProperties} EndIcon={t1} className={t2} disabled={disabled} fullWidth={true} inputClassName={inputClassName} labelClassName={labelClassName} /></div>;
    $[2] = disabled;
    $[3] = inputClassName;
    $[4] = labelClassName;
    $[5] = startTextFieldProperties;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== endTextFieldProperties || $[10] !== hideBorder || $[11] !== inputClassName || $[12] !== onSwap || $[13] !== parts[1] || $[14] !== swapButtonProperties) {
    t4 = parts[1] ? <><div className={styles.middle}><div className={styles["middle-line"]} /></div>{onSwap && <button {...swapButtonProperties} aria-label="swap selected items" className={styles["swap-button"]}><MaterialIcon className={styles["swap-button-icon"]} name="swap_horiz" variant="outlined" /></button>}<div className={styles.end}><TextField {...endTextFieldProperties} className={`${styles.input} ${hideBorder && "border-none"}`} fullWidth={true} inputClassName={inputClassName} /></div></> : null;
    $[9] = endTextFieldProperties;
    $[10] = hideBorder;
    $[11] = inputClassName;
    $[12] = onSwap;
    $[13] = parts[1];
    $[14] = swapButtonProperties;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <div className={styles["inputs-container"]}>{t3}{t4}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== error) {
    t6 = error ? <div className={styles.error}>{error}</div> : null;
    $[19] = error;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t5 || $[22] !== t6) {
    t7 = <div className={styles.box}>{t5}{t6}</div>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== hideHeader || $[25] !== startTopAppBarProperties) {
    t8 = !hideHeader && <TopAppBar {...startTopAppBarProperties} />;
    $[24] = hideHeader;
    $[25] = startTopAppBarProperties;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== hideSearchBar || $[28] !== isMobile || $[29] !== startPopoverSearchFieldProperties) {
    t9 = !hideSearchBar && <div className={styles["popover-header"]}><SearchField {...startPopoverSearchFieldProperties} color={isMobile ? "white" : "transparent"} /></div>;
    $[27] = hideSearchBar;
    $[28] = isMobile;
    $[29] = startPopoverSearchFieldProperties;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className={styles["popover-list-divider"]} />;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== parts[0]?.loading) {
    t11 = parts[0]?.loading ? <div className={styles.loading}><Loading size={SizeType.lg} /><div>در حال جستجو هستیم</div></div> : null;
    $[32] = parts[0]?.loading;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const t12 = parts[0]?.NoResult ?? null;
  let t13;
  if ($[34] !== parts[0]?.historyTitle || $[35] !== parts[0]?.query || $[36] !== startHistoryItemsProperties) {
    t13 = !parts[0]?.query && startHistoryItemsProperties && startHistoryItemsProperties?.length > 0 ? <><div className={styles["popover-history-title"]}>{parts[0]?.historyTitle}</div>{startHistoryItemsProperties.map(_temp)}<div className={styles["popover-history-bottom"]} /></> : null;
    $[34] = parts[0]?.historyTitle;
    $[35] = parts[0]?.query;
    $[36] = startHistoryItemsProperties;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== parts[0]?.listTitle || $[39] !== startItemsProperties) {
    t14 = startItemsProperties && startItemsProperties?.length > 0 ? <>{parts[0]?.listTitle ? <div className={styles["popover-list-title"]}>{parts[0]?.listTitle}</div> : null}{startItemsProperties.map(_temp2)}</> : null;
    $[38] = parts[0]?.listTitle;
    $[39] = startItemsProperties;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t11 || $[42] !== t12 || $[43] !== t13 || $[44] !== t14) {
    t15 = <div className={styles["popover-list"]}>{t10}{t11}{t12}{t13}{t14}</div>;
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t15 || $[47] !== t8 || $[48] !== t9) {
    t16 = <div className={styles.popover}>{t8}{t9}{t15}</div>;
    $[46] = t15;
    $[47] = t8;
    $[48] = t9;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  let t17;
  if ($[50] !== startPopoverProperties || $[51] !== t16) {
    t17 = <PopoverFull {...startPopoverProperties}>{t16}</PopoverFull>;
    $[50] = startPopoverProperties;
    $[51] = t16;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== endHistoryItemsProperties || $[54] !== endItemsProperties || $[55] !== endPopoverProperties || $[56] !== endPopoverSearchFieldProperties || $[57] !== endTopAppBarProperties || $[58] !== endtags || $[59] !== isMobile || $[60] !== parts[1]) {
    t18 = parts[1] ? <PopoverFull {...endPopoverProperties}><div className={styles.popover}><TopAppBar {...endTopAppBarProperties} /><div className={styles["popover-header"]}><SearchField {...endPopoverSearchFieldProperties} color={isMobile ? "white" : "transparent"} /></div><div className={styles["popover-list"]}><div className={styles["popover-list-divider"]} />{parts[1]?.loading ? <div className={styles.loading}><Loading size={SizeType.lg} /><div>در حال جستجو هستیم</div></div> : null}{parts[1]?.NoResult ?? null}{!parts[1]?.query && endHistoryItemsProperties && endHistoryItemsProperties?.length > 0 ? <><div className={styles["popover-history-title"]}>{parts[1]?.historyTitle}</div>{endHistoryItemsProperties.map(_temp3)}<div className={styles["popover-history-bottom"]} /></> : null}{endItemsProperties && endItemsProperties?.length > 0 ? <>{parts[1]?.listTitle ? <div className={styles["popover-list-title"]}>{parts[1]?.listTitle}</div> : null}{endItemsProperties.map(_temp4)}</> : null}{endItemsProperties?.length === 0 && <div className="border-outline-thin flex flex-wrap gap-2 border-t px-6 py-2">{endtags.map(_temp5)}</div>}</div></div></PopoverFull> : null;
    $[53] = endHistoryItemsProperties;
    $[54] = endItemsProperties;
    $[55] = endPopoverProperties;
    $[56] = endPopoverSearchFieldProperties;
    $[57] = endTopAppBarProperties;
    $[58] = endtags;
    $[59] = isMobile;
    $[60] = parts[1];
    $[61] = t18;
  } else {
    t18 = $[61];
  }
  let t19;
  if ($[62] !== t0 || $[63] !== t17 || $[64] !== t18 || $[65] !== t7) {
    t19 = <div className={t0}>{t7}{t17}{t18}</div>;
    $[62] = t0;
    $[63] = t17;
    $[64] = t18;
    $[65] = t7;
    $[66] = t19;
  } else {
    t19 = $[66];
  }
  return t19;
};
function _temp(item) {
  return <ListItem key={item.id} {...item} />;
}
function _temp2(item_0) {
  return <ListItem key={item_0.id} {...item_0} />;
}
function _temp3(item_1) {
  return <ListItem key={item_1.id} {...item_1} />;
}
function _temp4(item_2) {
  return <ListItem key={item_2.id} {...item_2} />;
}
function _temp5(item_3) {
  return <Chips key={item_3.id} {...item_3} className="cursor-pointer" color="primary" text={item_3.title} variant="outline" />;
}